const ButtonColorsEnum=
{
    Primary:'primary',
    Secondary:'secondary',
    Success:'success',
    Danger:'danger',
    Warning:'warning',
    Destruct:'figmabuttondestroy destroy',
    Common:'figmabuttoncommon common',

};

export default ButtonColorsEnum;